import React, { FC } from 'react';

import { useCartItemsCount } from 'features/cart/hooks/use-cart-items-count';

import { useIsMobileBreakpoint } from 'hooks/use-media-query';
import { useServiceModeLive } from 'state/service-mode';

import { SimpleHomePageDesktop } from './simple-home-page-desktop';
import { SimpleHomePageMobile } from './simple-home-page-mobile';
import { ISimpleHomePageItemProps } from './types';

const SimpleHomePage: FC<React.PropsWithChildren<ISimpleHomePageItemProps>> = ({
  item,
  flatListDimensions,
}) => {
  const isMobile = useIsMobileBreakpoint();
  const serviceMode = useServiceModeLive();
  const numberOfItemsInCart = useCartItemsCount();

  return isMobile ? (
    <SimpleHomePageMobile
      flatListDimensions={flatListDimensions}
      item={item}
      serviceMode={serviceMode}
      numberOfItemsInCart={numberOfItemsInCart}
    />
  ) : (
    <SimpleHomePageDesktop
      flatListDimensions={flatListDimensions}
      item={item}
      serviceMode={serviceMode}
      numberOfItemsInCart={numberOfItemsInCart}
    />
  );
};

export default React.memo(SimpleHomePage);
